import React from 'react';
import _ from 'lodash';
import TemplateBasicInfoComponent from './template-basic-info.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';


export const TemplateComponent = ({
  templates,
  tenantFunctions,
  handleFormItemChange,
  deleteSelectedFunctions,
  handleProductSearch,
  handleDeliverySearch,
  handleTierPriceSearch,
  handleCollectionPolicySearch,
  handleRewardPointSearch,
  handleDiscountSearch,
  handleVendorSearch,
  handleTopicSearch,
  handleModuleSearch,
  handleLearningPathSearch,
  handleCourseSearch,
  handleCollectionSearch,
  handleChannelSearch,
  handleCertificateSearch,
  handleAnnouncementSearch,
  handleCategorySearch,
  products,
  deliveries,
  collectionPolicies,
  tierPrices,
  rewards,
  discounts,
  organizationUnits,
  vendors,
  topics,
  modules,
  learningPaths,
  courses,
  collections,
  channels,
  certificates,
  announcements,
  categories,
  selectedFunctions,
  selectedTemplate,
  handleInnerFormChange,
  back,
  handleFormSubmit,
  changeImage,
  mediaFiles,
  handleFormAttachmentItemChange
}: any) => {
  const tabItems = [
    {
      id: 1,
      title: 'Template',
      component: <TemplateBasicInfoComponent selectedTemplate={selectedTemplate}
        handleInnerFormChange={handleInnerFormChange}
        changeImage={changeImage}
        mediaFiles={mediaFiles}
        handleFormAttachmentItemChange={handleFormAttachmentItemChange}
      />,
      isVisible: true,
    },
    //   {
    //     id:2,
    //     title:'Mapped Entities',
    //     component:<TemplatedMappedInfoComponent   
    //     templates={templates}
    //     tenantFunction={tenantFunctions}
    //     selectedFunction={selectedFunctions}
    //     categories={categories}
    //     deleteSelectedFunctions={deleteSelectedFunctions}
    //     handleInnerFormChange={handleInnerFormChange}
    //     handleFormItemChange={handleFormItemChange}
    //     announcements={announcements}
    //     // certificates={certificates}
    //     channels={channels}
    //     // collections={collections}
    //     // courses={courses}
    //     // learningPaths={learningPaths}
    //     // modules={modules}
    //     topics={topics}
    //     // vendors={vendors}
    //     organizationUnits={organizationUnits}
    //     discounts={discounts}
    //     rewards={rewards}
    //     tierPrices={tierPrices}
    //     collectionPolicies={collectionPolicies}
    //     deliveries={deliveries}
    //     products={products}
    //     handleCategorySearch={handleCategorySearch}
    //     handleAnnouncementSearch={handleAnnouncementSearch}
    //     // handleCertificateSearch={handleCertificateSearch}
    //     handleChannelSearch={handleChannelSearch}
    //     // handleCollectionSearch={handleCollectionSearch}
    //     // handleCourseSearch={handleCourseSearch}
    //     // handleLearningPathSearch={handleLearningPathSearch}
    //     // handleModuleSearch={handleModuleSearch}
    //     handleTopicSearch={handleTopicSearch}
    //     // handleVendorSearch={handleVendorSearch}
    //     handleDiscountSearch={handleDiscountSearch}
    //     handleRewardPointSearch={handleRewardPointSearch}
    //     handleCollectionPolicySearch={
    //       handleCollectionPolicySearch
    //     }
    //     handleTierPriceSearch={handleTierPriceSearch}
    //     handleDeliverySearch={handleDeliverySearch}
    //     handleProductSearch={handleProductSearch}
    //   />,
    // isVisible:true,
    // },

  ]

  return (
    <>



      <TabContainer tabItems={tabItems} />



      <div className='flex w-full justify-end items-end'>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>

    </>
  );
};
export default TemplateComponent;
